import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsAccordionModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { TranslateModule } from '@ngx-translate/core';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsTooltipConditionalModule } from '../../detail/pillar-two/transcript-summary/tooltip-conditional.module';

import { CaLiveEvaluationComponent } from './ca-live-evaluation.component';

@NgModule({
    declarations: [CaLiveEvaluationComponent],
    exports: [CaLiveEvaluationComponent],
    imports: [
        CmpsAccordionModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsTooltipConditionalModule,
        CmpsTooltipModule,
        CommonModule,
        TranslateModule,
    ],
})
export class CmpsCaLiveEvaluationModule {}
